import dayjs from 'dayjs'
import { Timestamp, OrderResp, File, XvOrdersResp_Order, OrdersResp_Order, OrderToAdmResp_Order, XvOrderResp_Order } from '@/apiv3/index'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  formatDate: function (value: string | undefined): string {
    if (value === null) {
      return ''
    }

    return dayjs(value).format('DD.MM.YYYY HH:mm')
  },

  formatDateTs: function (value: Timestamp | undefined): string {
    if (value === null || value === undefined) {
      return ''
    }

    const dt = new Date(Number(value.seconds) * 1000)
    return dayjs(dt.toISOString()).format('DD.MM.YYYY HH:mm')
  },

  formatDayNear: function (value: string | undefined): string {
    if (value === null) {
      return ''
    }

    return dayjs(value).format('DD.MM HH:mm')
  },

  formatDateNear: function (value: string | undefined): string {
    if (value === null) {
      return ''
    }

    return dayjs(value).format('DD.MM')
  },

  formatDateOnly: function (value: string | undefined): string {
    if (value === null) {
      return ''
    }

    return dayjs(value).format('DD.MM.YYYY')
  },

  formatDateOnlyTs: function (value: Timestamp | undefined): string {
    if (value === null || value === undefined) {
      return ''
    }

    const dt = new Date(Number(value.seconds) * 1000)
    return dayjs(dt.toISOString()).format('DD.MM.YYYY')
  },

  getFileURL (file: File, ord: OrderResp | OrdersResp_Order | OrderToAdmResp_Order | null | undefined): string {
    let name = file.name
    if (ord && !(name && ord.number && name.startsWith(ord.number))) {
      name = ord.number + ' ' + file.name
    }

    return 'https://prepodam.ru/api/v2/file/' + file.guid + '/' + file.secret + '/' + name
  },

  getXvFileURL (file: File, ord: XvOrdersResp_Order | XvOrderResp_Order | null): string {
    let name = file.name
    if (ord && !(name && ord.seasonId && name.startsWith(ord.seasonId.toString()))) {
      name = ord.seasonId.toString() + ' ' + file.name
    }

    return 'https://xvostov.net/api/v2/file/' + file.guid + '/' + file.secret + '/' + name
  },

  delta (finishDate: Timestamp | undefined): number {
    if (finishDate === undefined) {
      return 0
    }

    const dt = new Date(Number(finishDate.seconds) * 1000)

    const now = dayjs().tz('Europe/Moscow')

    // second = 1 to get strict delta=1 if one day diff
    const finish = dayjs(dt).tz('Europe/Moscow').hour(23).minute(0).second(1)
    const nowTrunced = now.hour(23).minute(0).second(0)

    let delta = finish.diff(nowTrunced, 'days')

    if (now.hour() >= 20 && delta > 0) {
      delta -= 1
    }

    return delta
  },

  getAmount (val: string): number {
    const amount = Number.parseInt(val, 10)
    if (Number.isNaN(amount)) {
      return 0
    }

    return amount
  },

  dateTsToInputValue: function (value: Timestamp | undefined): string {
    if (value === null || value === undefined) {
      return ''
    }

    const dt = new Date(Number(value.seconds) * 1000)
    return dayjs(dt.toISOString()).format('YYYY-MM-DDTHH:mm')
  },

  dateStringToInputValue: function (value: string): string {
    return dayjs(value).format('YYYY-MM-DDTHH:mm')
  },

  inputValueToDateTs: function (value: string): Timestamp {
    return Timestamp.fromDate(dayjs(value).toDate())
  },

  getQueryParameter (val: string | (string | null)[]): string {
    if (val === undefined) {
      return ''
    }

    if (Array.isArray(val)) {
      if (val[0] !== undefined && val[0] !== null) {
        return val[0]
      }

      return ''
    } else {
      return val
    }
  },

  setQueryParameters (val: Map<string, string>): string {
    const params = new URLSearchParams()

    val.forEach((v, k) => {
      params.set(k, v)
    })

    return params.toString()
  }
}
